import React from 'react';
import * as PropTypes from 'prop-types';
import { Table } from 'semantic-ui-react';

import ProductTableRow from './ProductTableRow';
import SortableHeaderCell from '../common/SortableHeaderCell';
import { getActiveItems } from '../../utils/PartyUtils';
import { useAppSelector } from '../../actions/store';
import { orderBy } from 'lodash';
import { ProductListMode } from './ProductList';
import FeatureFlag from '../common/FeatureFlag';

interface ProductListProps {
    entities: any[];
    handleSortChange: (sortField: string) => void;
    paginationOptions: object;
    handleAddFilter: (filters: object) => void;
    removeFilterValues: (filters: string[]) => void;
    currentFilters: object;
    mode?: ProductListMode;
    displayedColumns?: string[];
    fetchProducts?: () => void;
    hideActionButtons?: boolean;
}

const ProductList = (props: ProductListProps) => {
    const entityType = useAppSelector(
        (state) => state.entity.entityTypes.byId['PRODUCT'],
    );

    const selectedEntities = useAppSelector(
        (state) => state.entity.selectedEntities,
    );

    const {
        entities,
        handleSortChange,
        paginationOptions,
        handleAddFilter,
        removeFilterValues,
        currentFilters,
        fetchProducts,
        displayedColumns,
    } = props;

    const renderProductList = () => {
        return getActiveItems(entities).map((product) => (
            <ProductTableRow
                displayedColumns={displayedColumns}
                product={product}
                key={product.id}
                mode={props.mode}
                selected={selectedEntities.includes(product.id)}
                fetchProducts={fetchProducts}
                hideActionButtons={props.hideActionButtons}
            />
        ));
    };

    /*
    const orderedFields = orderBy(
        entityType?.fields?.filter(
            (field) => field.activityFieldType !== 'Hidden',
        ),
        ['sort'],
    );
*/

    return (
        <Table celled sortable unstackable>
            <Table.Header>
                <Table.Row>
                    <SortableHeaderCell
                        {...paginationOptions}
                        name="label"
                        handleSortChange={handleSortChange}
                        handleAddFilter={handleAddFilter}
                        removeFilterValues={removeFilterValues}
                        currentFilters={currentFilters}
                    >
                        Product Label
                    </SortableHeaderCell>

                    {/*orderedFields?.map((field) => {
                        if (displayedColumns) {
                            return displayedColumns.includes(field.id) ? (
                                <SortableHeaderCell
                                    {...paginationOptions}
                                    name={field.id}
                                    handleSortChange={handleSortChange}
                                    handleAddFilter={handleAddFilter}
                                    removeFilterValues={removeFilterValues}
                                    currentFilters={currentFilters}
                                >
                                    {field.label}
                                </SortableHeaderCell>
                            ) : null;
                        }
                        return (
                            <SortableHeaderCell
                                {...paginationOptions}
                                name={field.id}
                                handleSortChange={handleSortChange}
                                handleAddFilter={handleAddFilter}
                                removeFilterValues={removeFilterValues}
                                currentFilters={currentFilters}
                            >
                                {field.label}
                            </SortableHeaderCell>
                        );
                    })*/}
                    <FeatureFlag featureFlag="Client1Specific" showHide={false}>
                        <SortableHeaderCell
                            {...paginationOptions}
                            name="reference"
                            handleSortChange={handleSortChange}
                            handleAddFilter={handleAddFilter}
                            removeFilterValues={removeFilterValues}
                            currentFilters={currentFilters}
                        >
                            Reference
                        </SortableHeaderCell>
                        <SortableHeaderCell
                            {...paginationOptions}
                            name="classOfBusiness"
                            handleSortChange={handleSortChange}
                            handleAddFilter={handleAddFilter}
                            removeFilterValues={removeFilterValues}
                            currentFilters={currentFilters}
                        >
                            Class of Business
                        </SortableHeaderCell>
                        <SortableHeaderCell
                            {...paginationOptions}
                            name="fcaCategory"
                            handleSortChange={handleSortChange}
                            handleAddFilter={handleAddFilter}
                            removeFilterValues={removeFilterValues}
                            currentFilters={currentFilters}
                        >
                            FCA Category
                        </SortableHeaderCell>

                        <SortableHeaderCell
                            {...paginationOptions}
                            name="riskCode"
                            handleSortChange={handleSortChange}
                            handleAddFilter={handleAddFilter}
                            removeFilterValues={removeFilterValues}
                            currentFilters={currentFilters}
                        >
                            Risk Code
                        </SortableHeaderCell>
                        <SortableHeaderCell
                            {...paginationOptions}
                            name="productGroup"
                            handleSortChange={handleSortChange}
                            handleAddFilter={handleAddFilter}
                            removeFilterValues={removeFilterValues}
                            currentFilters={currentFilters}
                        >
                            Product Group
                        </SortableHeaderCell>
                    </FeatureFlag>
                    <FeatureFlag featureFlag="Client1Specific" showHide={true}>
                        <SortableHeaderCell
                            {...paginationOptions}
                            name="productSegment"
                            handleSortChange={handleSortChange}
                            handleAddFilter={handleAddFilter}
                            removeFilterValues={removeFilterValues}
                            currentFilters={currentFilters}
                        >
                            Segment
                        </SortableHeaderCell>
                        <SortableHeaderCell
                            {...paginationOptions}
                            name="productClass"
                            handleSortChange={handleSortChange}
                            handleAddFilter={handleAddFilter}
                            removeFilterValues={removeFilterValues}
                            currentFilters={currentFilters}
                        >
                            Class
                        </SortableHeaderCell>
                        <SortableHeaderCell
                            {...paginationOptions}
                            name="riskRatingLabel"
                            handleSortChange={handleSortChange}
                            handleAddFilter={handleAddFilter}
                            removeFilterValues={removeFilterValues}
                            currentFilters={currentFilters}
                        >
                            Risk Level
                        </SortableHeaderCell>
                        <SortableHeaderCell
                            {...paginationOptions}
                            name="productOwner"
                            handleSortChange={handleSortChange}
                            handleAddFilter={handleAddFilter}
                            removeFilterValues={removeFilterValues}
                            currentFilters={currentFilters}
                        >
                            Owner
                        </SortableHeaderCell>
                        <SortableHeaderCell
                            {...paginationOptions}
                            name="productReviewer"
                            handleSortChange={handleSortChange}
                            handleAddFilter={handleAddFilter}
                            removeFilterValues={removeFilterValues}
                            currentFilters={currentFilters}
                        >
                            Reviewer
                        </SortableHeaderCell>
                        <SortableHeaderCell
                            {...paginationOptions}
                            name="archivedDisplay"
                            handleSortChange={handleSortChange}
                            handleAddFilter={handleAddFilter}
                            removeFilterValues={removeFilterValues}
                            currentFilters={currentFilters}
                        >
                            Archived
                        </SortableHeaderCell>
                    </FeatureFlag>
                    {!props.hideActionButtons && (
                        <Table.HeaderCell collapsing>Actions</Table.HeaderCell>
                    )}
                </Table.Row>
            </Table.Header>
            <Table.Body>{renderProductList()}</Table.Body>
        </Table>
    );
};

export default ProductList;
